import React, { useState } from "react";
import { createPortal } from "react-dom";
import { X, Lock, Eye, EyeOff, Loader2 } from "lucide-react";
import { toast } from "sonner";
// API faylınızın yerləşdiyi ünvandan re-export olunan funksiyanı import edin:
import { resetPassword } from "@/lib/api"; // Faylınızın dəqiq yolunu yazın (məs: "@/api" və ya "@/services/api")

export const ResetPasswordModal = ({ isOpen, onClose }) => {
    const [formData, setFormData] = useState({
        password: "",
        passwordConfirmation: "",
    });
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [loading, setLoading] = useState(false);

    if (!isOpen) return null;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.password || !formData.passwordConfirmation) {
            toast.error("Xahiş olunur, bütün xanaları doldurun!");
            return;
        }

        if (formData.password.length < 4) {
            toast.error("Şifrə ən azı 4 simvoldan ibarət olmalıdır!");
            return;
        }

        if (formData.password !== formData.passwordConfirmation) {
            toast.error("Şifrələr bir-biri ilə üst-üstə düşmür!");
            return;
        }

        setLoading(true);

        try {
            // Layihənin öz hazir API funksiyası çağırılır (token avtomatik ötürülür)
            await resetPassword(formData.password, formData.passwordConfirmation);

            toast.success("Şifrəniz uğurla dəyişdirildi!");
            setFormData({ password: "", passwordConfirmation: "" });
            onClose();
        } catch (error) {
            // API xətaları (ApiError) avtomatik error.message kimi buraya düşür
            toast.error(error?.message || "Şifrə dəyişdirilərkən xəta baş verdi!");
        } finally {
            setLoading(false);
        }
    };

    return createPortal(
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-fadeIn">
            {/* Qara arxa fona kliklədikdə modalın bağlanması */}
            <div className="fixed inset-0" onClick={onClose} />

            {/* Əsas Modal Qutusu */}
            <div className="relative z-10 w-full max-w-md bg-white rounded-2xl shadow-2xl p-6 md:p-8 transition-all">

                {/* Bağlamaq düyməsi */}
                <button
                    onClick={onClose}
                    type="button"
                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors p-1 rounded-full hover:bg-gray-100"
                >
                    <X size={20} />
                </button>

                {/* Modal Başlığı */}
                <div className="flex flex-col items-center mb-6 text-center">
                    <div className="w-12 h-12 bg-teal-50 text-[#00b4a2] rounded-full flex items-center justify-center mb-3">
                        <Lock size={24} />
                    </div>
                    <h2 className="text-xl font-bold text-gray-800">Şifrəni Dəyiş</h2>
                    <p className="text-sm text-gray-500 mt-1">
                        Hesabınız üçün yeni şifrə təyin edin
                    </p>
                </div>

                {/* Forma */}
                <form onSubmit={handleSubmit} className="space-y-4">
                    {/* Yeni Şifrə Inputu */}
                    <div>
                        <label className="block text-xs font-semibold text-gray-600 uppercase mb-1">
                            Yeni Şifrə *
                        </label>
                        <div className="relative">
                            <input
                                type={showPassword ? "text" : "password"}
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                placeholder="Yeni şifrənizi daxil edin"
                                className="w-full px-4 py-2.5 pr-10 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#00b4a2] text-sm transition-all"
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                            >
                                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                            </button>
                        </div>
                    </div>

                    {/* Yeni Şifrə Təkrarı Inputu */}
                    <div>
                        <label className="block text-xs font-semibold text-gray-600 uppercase mb-1">
                            Yeni Şifrə Təkrarı *
                        </label>
                        <div className="relative">
                            <input
                                type={showConfirmPassword ? "text" : "password"}
                                name="passwordConfirmation"
                                value={formData.passwordConfirmation}
                                onChange={handleChange}
                                placeholder="Şifrəni yenidən daxil edin"
                                className="w-full px-4 py-2.5 pr-10 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#00b4a2] text-sm transition-all"
                            />
                            <button
                                type="button"
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                            >
                                {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                            </button>
                        </div>
                    </div>

                    {/* Düymələr */}
                    <div className="flex gap-3 pt-4">
                        <button
                            type="button"
                            onClick={onClose}
                            className="w-1/2 py-2.5 px-4 rounded-xl border border-gray-200 text-gray-700 font-medium hover:bg-gray-50 transition-colors text-sm"
                        >
                            Ləğv et
                        </button>
                        <button
                            type="submit"
                            disabled={loading}
                            className="w-1/2 py-2.5 px-4 rounded-xl bg-[#00b4a2] hover:bg-[#009b8b] text-white font-medium transition-colors text-sm flex items-center justify-center gap-2 disabled:opacity-50"
                        >
                            {loading ? (
                                <>
                                    <Loader2 className="animate-spin" size={18} />
                                    Yenilənir...
                                </>
                            ) : (
                                "Yadda saxla"
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>,
        document.body
    );
};